import React from 'react';
import { Modal, TextInput } from '@mantine/core';
import { Button } from '../../../../components/Button/Button';
import navyModal from '../../../../components/Modal/navy-modal.module.scss';
import classes from './stationary-setup-modal.module.scss';

type StationarySetupModalProps = {
  opened: boolean;
  isSaving: boolean;
  value: string | null;
  onClose: () => void;
  onSave: (name: string | null) => void;
};

const NO_SELECTION_INPUT_PROPS = {
  onContextMenu: (event: React.MouseEvent<HTMLInputElement>) => event.preventDefault(),
  onSelect: (event: React.SyntheticEvent<HTMLInputElement>) => event.preventDefault(),
};

export const StationarySetupModal: React.FC<StationarySetupModalProps> = ({
  opened,
  isSaving,
  value,
  onClose,
  onSave,
}) => {
  const [name, setName] = React.useState(value ?? '');

  React.useEffect(() => {
    if (!opened) {
      return;
    }
    setName(value ?? '');
  }, [opened, value]);

  const normalized = name.trim();
  const isDirty = (value ?? '') !== normalized;

  return (
    <Modal
      opened={opened}
      onClose={() => {
        if (!isSaving) {
          onClose();
        }
      }}
      onContextMenu={(event) => event.preventDefault()}
      title={<span className={classes.title}>הגדר עמדה נייחת</span>}
      size="md"
      centered
      radius="md"
      classNames={{ root: navyModal.root }}
      closeButtonProps={{ 'data-testid': 'stationary-setup-close' } as Record<string, string>}
    >
      <div className={classes.body} dir="rtl">
        <TextInput
          data-testid="stationary-setup-input"
          label="שם עמדה"
          placeholder="לדוגמה: עמדה ראשית"
          value={name}
          onChange={(event) => setName(event.currentTarget.value)}
          maxLength={50}
          disabled={isSaving}
          {...NO_SELECTION_INPUT_PROPS}
        />

        <p className={classes.hint}>השאר ריק כדי לבטל הגדרת עמדה נייחת.</p>

        <div className={classes.actions}>
          <Button variant="cancel" onClick={onClose} disabled={isSaving} dataTestId="stationary-setup-cancel">
            ביטול
          </Button>
          <Button
            variant="save"
            onClick={() => onSave(normalized.length > 0 ? normalized : null)}
            disabled={isSaving || !isDirty}
            loading={isSaving}
            dataTestId="stationary-setup-save"
          >
            שמור
          </Button>
        </div>
      </div>
    </Modal>
  );
};
